import { STATUS_TS, TEAM_TYPE } from 'interfaces/TeamSale/TeamSale';

export const TEAM_TYPE_OPTIONS = [
  {
    label: 'Tại chỗ',
    value: TEAM_TYPE.stay,
  },
  {
    label: 'Chào hàng',
    value: TEAM_TYPE.store,
  },
];

export const STATUS_TS_OPTIONS = [
  {
    label: 'Hoạt động',
    value: STATUS_TS.active,
  },
  {
    label: 'Không hoạt động',
    value: STATUS_TS.notActive,
  },
];
